<script>
import { useForm } from '@inertiajs/vue3'
import { ref } from 'vue'
import InputError from '@/Shared/Components/Forms/InputError.vue'
import InputLabel from '@/Shared/Components/Forms/InputLabel.vue'
import TextInput from '@/Shared/Components/Forms/TextInput.vue'
import AppLink from '@/Shared/Components/Links/AppLink.vue'
import TextAreaInput from '@/Shared/Components/Forms/TextAreaInput.vue'
import PrimaryButton from '@/Shared/Components/Buttons/PrimaryButton.vue'
import SelectInput from '@/Shared/Components/Forms/SelectInput.vue'
</script>

<script setup>
const props = defineProps({
  stop: Object,
  types: Object,
})

const form = useForm({
  stop_name: props.stop.stop_name,
  type: null,
  description: null,
})

const sending = ref(false)
const finished = ref(false)
const submit = () => {
  sending.value = true

  axios
    .post(route('stop-issue.send'), {
      stop_name: props.stop.stop_name,
      type: form.type,
      description: form.description,
      bearing: props.stop.bearing,
      naptan: props.stop.stop_naptan,
      atco: props.stop.stop_id,
      indicator: props.stop.indicator,
    })
    .then(() => {
      finished.value = true
    })
    .catch((error) => {
      form.clearErrors()
      form.setError('description', error.response.data.errors.description[0])
      form.setError('type', error.response.data.errors.type[0])
    })
    .finally(() => {
      sending.value = false
    })
}
</script>

<template>
  <div class="max-w-7xl mx-auto mt-4">
    <div v-if="!finished">
      <div>
        <h1 class="text-black font-extrabold text-xl py-8">Leave feedback</h1>
        <p>Please use this form to provide feedback on this bus stop</p>
      </div>
      <form
        class="mb-5 mt-10"
        @submit.prevent="submit"
      >
        <div :class="form.errors.stop_name ? 'border-l-4 pl-2 border-red-600 ' : undefined">
          <InputLabel
            class="font-bold"
            for="stop_name"
            value="Bus stop name"
          />
          <InputError
            class="mt-2"
            :message="form.errors.stop_name"
          />
          <TextInput
            id="stop_name"
            v-model="form.stop_name"
            type="text"
            class="mt-1 block w-full md:w-1/4"
            disabled
          />
        </div>

        <div :class="form.errors.type ? 'border-l-4 pl-2 border-red-600 ' : undefined">
          <InputLabel
            class="font-bold mt-4"
            for="type"
            value="Type"
          />
          <InputError
            class="mt-2"
            :message="form.errors.type"
          />
          <SelectInput
            id="select_field"
            v-model="form.type"
            class="mt-1 w-full md:w-1/4"
            placeholder="Please select..."
            :items="types"
            :model-value="form.type"
          ></SelectInput>
        </div>
        <div :class="form.errors.description ? 'border-l-4 pl-2 border-red-600 ' : undefined">
          <InputLabel
            class="font-bold mt-5"
            for="description"
            value="Description"
          />
          <InputError
            class="mt-2"
            :message="form.errors.description"
          />
          <TextAreaInput
            id="description"
            v-model="form.description"
            type="text"
            rows="7"
            class="mt-1 block w-full md:w-1/3"
          />
          <div class="md:w-1/3 mt-1">
            <span class="float-right text-sm">Max 500 characters</span>
          </div>
        </div>
        <PrimaryButton class="mt-10">Submit</PrimaryButton>
      </form>
      <div class="mt-6">
        <AppLink
          class="mt-5"
          :href="route('stop-details.show', { stop_id: stop.stop_id })"
        >
          Cancel
        </AppLink>
      </div>
    </div>
    <div v-else>
      <div>
        <h1 class="text-black font-extrabold text-xl py-8">Feedback submitted</h1>
        <p>Thank you for providing feedback. We will look into any issues raised.</p>
      </div>
      <PrimaryButton
        class="mt-10"
        as="a"
        :href="route('stop-details.show', { stop_id: stop.stop_id })"
      >
        Back to bus stop
      </PrimaryButton>
    </div>
  </div>
</template>
